module.exports = __webpack_public_path__ + "assets/images/fb-3MJx9cY.png";